import React from 'react';
import Hero from '../components/Hero/Hero';
import Services from '../components/Services/Services';
import Solutions from '../components/Solutions/Solutions';
import About from '../components/About/About';
import Testimonials from '../components/Testimonials/Testimonials';
import Contact from '../components/Contact/Contact';

const HomePage = () => {
  return (
    <>
      <Hero />
      <Services />
      <Solutions />
      <About />
      <Testimonials />
      <Contact />
    </>
  );
};

export default HomePage;
